import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
@Injectable({
  providedIn: 'root',
})
export class GbStripeFacade implements GbBaseFacade {
  constructor(private readonly store: Store) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
